import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";

export default {
  DoGetAutoCompleteAssetTemplate(searchText) {
    let _input = {
      assetSubCategoryId: 0,
      assetCategoryId: 0,
      searchText: searchText,
    };

    return API.peakRealTimeAPI
      .post("/api/Asset/GetAutoCompleteAssetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAutoCompleteAsset(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateId: input.assetTemplateId,
      searchText: input.searchText,
    };
    return API.peakAPI
      .post("/api/Asset/GetAutoCompleteAsset", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  GetAssetTemplateListById(assetTemplateIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetTemplateIdList: assetTemplateIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetAssetTemplateListById", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
  GetAssetCodeByIdList(assetIdList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      assetIdList: assetIdList,
    };
    return API.peakRealTimeAPI
      .post("/api/Asset/GetAssetCodeByIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      })
      
  },
};
